export const AI_QUEUE_SORT_KEYS = ["job", "status", "submitted", "finished"] as const;

export type AiQueueSortKey = typeof AI_QUEUE_SORT_KEYS[number];
export type AiQueueSortDirection = "ascending" | "descending";
export interface AiQueueSort {
  key: AiQueueSortKey;
  direction: AiQueueSortDirection;
}

export function defaultAiQueueSortDirection(key: AiQueueSortKey): AiQueueSortDirection {
  return key === "submitted" || key === "finished" ? "descending" : "ascending";
}

export function updateAiQueueSort(current: AiQueueSort | null, key: AiQueueSortKey): AiQueueSort | null {
  const defaultDirection = defaultAiQueueSortDirection(key);
  if (!current || current.key !== key) return { key, direction: defaultDirection };
  if (current.direction === defaultDirection) {
    return { key, direction: defaultDirection === "ascending" ? "descending" : "ascending" };
  }
  return null;
}
